export const titleCase = (str) => {
  str = str.replaceAll("_", " ")
    str = str.toLowerCase().split(' ');
    let final = [ ];
     for(let  word of str){
       final.push(word.charAt(0).toUpperCase()+ word.slice(1));
     }
   return final.join(' ')
}

export const csvStringToDict = (str, headersComparison = null, delim = ',') => {
  
  var responseData = {isError: false, data: []}

  const headersUnTrim = str.slice(0,str.indexOf('\n')).split(delim);
  const rows = str.slice(str.indexOf('\n') + 1).split('\n');
  
  const headers = headersUnTrim.map((data) => { return data.trim() });
  
  if (headersComparison) {
    headersComparison.map((data) => {
      if (!(headers.indexOf(data) > -1)) {
        responseData = { isError: true, msg: "Columns headers are mismatching." }
      }
      return "";
    })
  }

  const newArray = rows.map( row => {  
    const values = row.split(delim);
    const eachObject = headers.reduce((obj, header, i) => {  
      obj[header] = values[i] ? values[i].trim() ? values[i].trim() : null : null;
      return obj;
    }, {})  
    return eachObject;
  })

  responseData["data"] = newArray;

  return responseData;
}

export const getCurrentDateInput = () => {

  const dateObj = new Date();

  // get the month in this format of 04, the same for months
  const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
  const day = ("0" + dateObj.getDate()).slice(-2);
  const year = dateObj.getFullYear();

  const shortDate = `${year}-${month}-${day}`;

  return shortDate;
};
